export const TOGGLE_MODAL_CASHIER = 'TOGGLE_MODAL_CASHIER';

export function toggleModalCashier(cashierType, providerType = null) {
  return {
    type: TOGGLE_MODAL_CASHIER,
    cashierType,
    providerType,
  };
}
